import styles from './awards-by-programme-list.module.scss'
import { ProgrammeAwardIcon } from './programme-award-icon'
import React, { useCallback } from 'react'
import { Award } from 'src/dao/core-dao'
import { useAvailableProgrammeAwards, useProgrammeAwardsByProgramme } from 'src/hook/use-programme-awards'

export const AwardsByProgrammeList = ({ programmeId }: { programmeId: string }): React.ReactElement => {
  const { data: allAvailableAwards = [] } = useAvailableProgrammeAwards(programmeId)
  const { data: awardsByProgramme = [] } = useProgrammeAwardsByProgramme(programmeId)

  const isAwardCompleted = useCallback(
    (award: Award): boolean => {
      const awards = awardsByProgramme.find((aw) => aw?.award?.name === award?.name)
      return !!awards
    },
    [awardsByProgramme],
  )

  return (
    <div className={styles.awardsList}>
      {allAvailableAwards.map((item) => (
        <ProgrammeAwardIcon key={item.id} award={item} isCompleted={isAwardCompleted(item)} />
      ))}
    </div>
  )
}
